module.exports = require("core-js/library/fn/symbol");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/symbol.js
// module id = 120
// module chunks = 35783957827783 114276838955818 162898551421021